import {
  ALGOLIA_CLASSES_INDEX_BASE,
  ALGOLIA_MEDITATIONS_INDEX_BASE,
  ALGOLIA_BREATHWORK_INDEX_BASE,
  ALGOLIA_SERIES_INDEX_BASE,
  ALGOLIA_WORKSHOPS_INDEX_BASE,
  ALGOLIA_PREMIUM_TRAININGS_INDEX_BASE,
  ALGOLIA_CHALLENGES_INDEX_BASE,
  ALGOLIA_PODCASTS_INDEX_BASE,
  ALGOLIA_ARTICLES_INDEX_BASE,
  ALGOLIA_TEACHERS_INDEX_BASE,
} from './IndexBase';

export const siteWideSearchBaseIndexes = [
  ALGOLIA_CLASSES_INDEX_BASE,
  ALGOLIA_MEDITATIONS_INDEX_BASE,
  ALGOLIA_BREATHWORK_INDEX_BASE,
  ALGOLIA_SERIES_INDEX_BASE,
  ALGOLIA_WORKSHOPS_INDEX_BASE,
  ALGOLIA_PREMIUM_TRAININGS_INDEX_BASE,
  ALGOLIA_CHALLENGES_INDEX_BASE,
  ALGOLIA_PODCASTS_INDEX_BASE,
  ALGOLIA_ARTICLES_INDEX_BASE,
  ALGOLIA_TEACHERS_INDEX_BASE,
] as const;
